import classNames from 'classnames';
import { ComponentType, ReactElement } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { S_Link2 } from '../../design/links/S_Link2';

interface IProps {
  name: string;
  icon: ComponentType<{ className: string }>;
  link: string;
  highlightLink: string;
  disabled: boolean;
  isExpanded: boolean;
  id?: string;
  title?: string;
}

export const SideNavigationItem = ({ name, icon, link, highlightLink, disabled, isExpanded, id, title }: IProps): ReactElement => {
  const match = useRouteMatch();
  const isActive = match.path.includes(highlightLink);
  const Icon = icon;

  return (
    <div
      id={id}
      className={classNames({ active: isActive, disabled, expanded: isExpanded }, 'side-navigation-item')}
      title={title}
    >
      <S_Link2
        color='text'
        to={link}
        disabled={disabled}
        className='side-navigation-link'
      >
        <Icon className='side-navigation-icon' />
        {isExpanded && <div className='side-navigation-label'>{name}</div>}
      </S_Link2>
    </div>
  );
};
